module.exports = __webpack_public_path__ + "media/images/emblems/Ottenbach-blazon-8de4030074d1010a8f5e53d970989559.svg";